// removed by extract-text-webpack-plugin
module.exports = {"messages":"MemberProposalContainer__messages___1tgRc","noMessages":"MemberProposalContainer__noMessages___2XIX-","noMessagesText":"MemberProposalContainer__noMessagesText___1JObF","messagesContainer":"MemberProposalContainer__messagesContainer___oHX-m"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/employer/memberProposal/containers/MemberProposalContainer.scss
// module id = 1911
// module chunks = 0